// import React, { useState } from "react";
// import "./MemberRegistration.css";
// import cdrLogo from "../assets/icons/CDR-Logo.png";
// import { useNavigate } from "react-router-dom";
// import Select from "react-select";
// import axios from "axios";
// import countryList from "react-select-country-list";
// const STEPS = [
//   { num: 1, label: "Personal" },
//   { num: 2, label: "Membership" },
//   { num: 3, label: "Dues" },
//   { num: 4, label: "Address" },
// ];

// function StepTracker({ current }) {
//   return (
//     <div className="mr-stepbar">
//       {STEPS.map((s, i) => (
//         <React.Fragment key={s.num}>
//           <div
//             className={
//               "mr-step" +
//               (current === s.num ? " mr-step-active" : "") +
//               (current > s.num ? " mr-step-done" : "")
//             }
//           >
//             <div className="mr-step-circle">
//               {current > s.num ? "✓" : s.num}
//             </div>
//             <span className="mr-step-label">{s.label}</span>
//           </div>
//           {i < STEPS.length - 1 && (
//             <div
//               className={
//                 "mr-step-line" + (current > s.num ? " mr-line-done" : "")
//               }
//             />
//           )}
//         </React.Fragment>
//       ))}
//     </div>
//   );
// }

// function Field({ label, children, full }) {
//   return (
//     <div className={"mr-field" + (full ? " mr-field-full" : "")}>
//       <label className="mr-label">{label}</label>
//       {children}
//     </div>
//   );
// }

// export default function MemberRegistration() {
//   const [step, setStep] = useState(1);
//   const [omgdAdmissions, setOmgdAdmissions] = useState([]);
//   const [submitted, setSubmitted] = useState(false);
//   const navigate = useNavigate();
//   const [addressSuggestions, setAddressSuggestions] = useState([]);
//   const [showSuggestions, setShowSuggestions] = useState(false);
//   const [isSearchingAddress, setIsSearchingAddress] = useState(false);
//   // Country dropdown options
//   const nationalityOptions = countryList().getData();
//   const [formData, setFormData] = useState({
//     nationalBailliage: "VN",
//     dietaryRestrictions: "",
//     firstName: "",
//     lastName: "",
//     birthday: "",
//     title: "",
//     gender: "",
//     nationality: "",
//     spokenLanguages: "",
//     spouseMember: "",
//     gastronomicAssociation: "",
//     phone: "",
//     email: "",
//     provincialBailliage: "",
//     regionalBailliage: "",
//     membershipSponsor1: "",
//     membershipSponsor2: "",
//     membershipType: "",
//     grade: "",
//     relevantYear: "",
//     registrationDate: "",
//     priceCategory: "",
//     membershipAmount: "",
//     paymentDate: "",
//     searchAddress: "",
//     address: "",
//     additionalInfo: "",
//     country: "",
//     postalCode: "",
//     city: "",
//   });

//   const hc = (e) =>
//     setFormData({ ...formData, [e.target.name]: e.target.value });

//   const addAdmission = () =>
//     setOmgdAdmissions([
//       ...omgdAdmissions,
//       { relevantYear: "", registrationDate: "", priceCategory: "", amount: "" },
//     ]);
//   const removeAdmission = (i) =>
//     setOmgdAdmissions(omgdAdmissions.filter((_, idx) => idx !== i));
//   const handleOmgdChange = (i, field, value) => {
//     const updated = [...omgdAdmissions];
//     updated[i][field] = value;
//     setOmgdAdmissions(updated);
//   };

//   const goNext = (e) => {
//     e.preventDefault();
//     if (step < 4) setStep(step + 1);
//   };
//   const goPrev = (e) => {
//     e.preventDefault();
//     if (step > 1) setStep(step - 1);
//   };
//   const handleAddressSearch = async (e) => {
//     const value = e.target.value;

//     setFormData((prev) => ({
//       ...prev,
//       searchAddress: value,
//     }));

//     if (value.trim().length < 3) {
//       setAddressSuggestions([]);
//       setShowSuggestions(false);
//       return;
//     }

//     try {
//       setIsSearchingAddress(true);

//       const response = await axios.get(
//         "https://api.geoapify.com/v1/geocode/autocomplete",
//         {
//           params: {
//             text: value,
//             format: "json",
//             limit: 5,
//             apiKey: process.env.REACT_APP_GEOAPIFY_API_KEY,
//           },
//         },
//       );

//       console.log("Geoapify response:", response.data);

//       setAddressSuggestions(response.data.results || []);
//       setShowSuggestions(true);
//     } catch (error) {
//       console.error(
//         "Address search error:",
//         error.response?.data || error.message,
//       );

//       setAddressSuggestions([]);
//       setShowSuggestions(false);
//     } finally {
//       setIsSearchingAddress(false);
//     }
//   };
//   const handleSelectAddress = (place) => {
//     setFormData((prev) => ({
//       ...prev,

//       searchAddress: place.formatted || "",

//       address:
//         [place.housenumber, place.street].filter(Boolean).join(" ") ||
//         place.address_line1 ||
//         "",

//       additionalInfo: place.address_line2 || "",

//       city:
//         place.city || place.town || place.village || place.municipality || "",

//       state: place.state || place.state_district || "",

//       country: place.country || "",

//       postalCode: place.postcode || "",
//     }));

//     setShowSuggestions(false);
//     setAddressSuggestions([]);
//   };
//   // ── Success screen ────────────────────────────────────
//   if (submitted)
//     return (
//       <div className="mr-page">
//         <div className="mr-card mr-card-success">
//           <div className="mr-success-ring">
//             <img src={cdrLogo} alt="CDR" className="mr-success-logo" />
//           </div>
//           <h2 className="mr-success-title">Welcome to the Chaîne!</h2>
//           <p className="mr-success-desc">
//             <strong>
//               {formData.firstName} {formData.lastName}
//             </strong>{" "}
//             has been successfully registered. The membership application is now
//             pending review.
//           </p>
//           <button
//             className="mr-btn mr-btn-primary"
//             onClick={() => {
//               setSubmitted(false);
//               setStep(1);
//               setFormData({
//                 firstName: "",
//                 lastName: "",
//                 birthday: "",
//                 title: "",
//                 gender: "",
//                 nationality: "",
//                 spokenLanguages: "",
//                 dietaryRestrictions: "",
//                 spouseMember: "",
//                 gastronomicAssociation: "",
//                 phone: "",
//                 email: "",
//                 nationalBailliage: "VN",
//                 provincialBailliage: "",
//                 regionalBailliage: "",
//                 membershipSponsor1: "",
//                 membershipSponsor2: "",
//                 membershipType: "",
//                 grade: "",
//                 relevantYear: "",
//                 registrationDate: "",
//                 priceCategory: "",
//                 membershipAmount: "",
//                 paymentDate: "",
//                 searchAddress: "",
//                 address: "",
//                 additionalInfo: "",
//                 country: "",
//                 postalCode: "",
//                 city: "",
//               });
//               setOmgdAdmissions([]);
//             }}
//           >
//             Register Another Member
//           </button>

//           <div className="mr-login-box">
//             <p className="mr-login-text">Already have an account?</p>

//             <button
//               className="mr-login-btn"
//               onClick={() => navigate("/MemberLogin")}
//             >
//               Sign In
//             </button>
//           </div>
//         </div>
//       </div>
//     );

//   return (
//     <div className="mr-page">
//       <div className="mr-card">
//         {/* ── Header ── */}
//         <div className="mr-header">
//           <div className="mr-header-brand">
//             <div className="mr-logo-ring">
//               <img src={cdrLogo} alt="CDR Logo" className="mr-logo-img" />
//             </div>
//             <div>
//               <h1 className="mr-title">Member Registration</h1>
//               <p className="mr-subtitle">
//                 Chaîne des Rôtisseurs · New Member Admission
//               </p>
//             </div>
//           </div>
//           <StepTracker current={step} />
//         </div>

//         {/* ════ STEP 1: Personal ════ */}
//         {step === 1 && (
//           <>
//             <div className="mr-section">
//               <div className="mr-section-head">Personal Information</div>
//               <div className="mr-grid">
//                 <Field label="Title *">
//                   <select name="title" value={formData.title} onChange={hc}>
//                     <option value="">Select</option>
//                     <option>Lady</option>
//                     <option>Miss</option>
//                     <option>Mme.</option>
//                     <option>Mr.</option>
//                     <option>Mrs.</option>
//                     <option>Ms.</option>
//                     <option>prot.</option>
//                     <option>Tan Sri Dato</option>
//                     <option>Chef</option>
//                     <option>Count</option>
//                     <option>Dato</option>
//                     <option>Dato Seri</option>
//                     <option>Dr</option>
//                     <option>Lady</option>
//                   </select>
//                 </Field>
//                 <Field label="First Name *">
//                   <input
//                     name="firstName"
//                     value={formData.firstName}
//                     onChange={hc}
//                   />
//                 </Field>
//                 <Field label="Last Name *">
//                   <input
//                     name="lastName"
//                     value={formData.lastName}
//                     onChange={hc}
//                   />
//                 </Field>
//                 <Field label="Birthday *">
//                   <input
//                     type="date"
//                     name="birthday"
//                     value={formData.birthday}
//                     onChange={hc}
//                   />
//                 </Field>

//                 <Field label="Gender *">
//                   <select name="gender" value={formData.gender} onChange={hc}>
//                     <option value="">Select</option>
//                     <option>Male</option>
//                     <option>Female</option>
//                     <option>Other</option>
//                   </select>
//                 </Field>
//                 <Field label="Nationality *">
//                   <Select
//                     classNamePrefix="react-select"
//                     options={nationalityOptions}
//                     value={nationalityOptions.find(
//                       (option) => option.label === formData.nationality,
//                     )}
//                     onChange={(selectedOption) =>
//                       setFormData({
//                         ...formData,
//                         nationality: selectedOption ? selectedOption.label : "",
//                       })
//                     }
//                     placeholder="Select Nationality"
//                     isSearchable
//                     isClearable
//                   />
//                 </Field>

//                 <Field label="Additional Spoken Languages">
//                   <select
//                     name="spokenLanguages"
//                     value={formData.spokenLanguages}
//                     onChange={hc}
//                   >
//                     <option value="">Select Language</option>
//                     <option value="Chinese">Chinese</option>
//                     <option value="English">English</option>
//                     <option value="Korean">Korean</option>
//                     <option value="French">French</option>
//                     <option value="Japanese">Japanese</option>
//                     <option value="Spanish">Spanish</option>
//                     <option value="German">German</option>
//                     <option value="Italian">Italian</option>
//                   </select>
//                 </Field>

//                 <Field label="Dietary Restrictions">
//                   <select
//                     name="hasDietaryRestrictions"
//                     value={formData.hasDietaryRestrictions}
//                     onChange={hc}
//                   >
//                     <option value="">Select</option>
//                     <option value="Yes">Yes</option>
//                     <option value="No">No</option>
//                   </select>

//                   {formData.hasDietaryRestrictions === "Yes" && (
//                     <textarea
//                       rows="2"
//                       name="dietaryRestrictions"
//                       placeholder="Please specify dietary restrictions"
//                       value={formData.dietaryRestrictions}
//                       onChange={hc}
//                       style={{ marginTop: "10px" }}
//                     />
//                   )}
//                 </Field>
//                 <Field label="Spouse Member of La Chaîne">
//                   <input
//                     type="search"
//                     name="spouseMember"
//                     placeholder="Search ..."
//                     value={formData.spouseMember}
//                     onChange={hc}
//                   />
//                 </Field>
//                 <Field label="Other Gastronomic Associations" full>
//                   <textarea
//                     rows="3"
//                     name="gastronomicAssociation"
//                     value={formData.gastronomicAssociation}
//                     onChange={hc}
//                   />
//                 </Field>
//               </div>
//             </div>

//             <div className="mr-section">
//               <div className="mr-section-head">Contact Information</div>
//               <div className="mr-grid">
//                 <Field label="Personal Phone *">
//                   <input name="phone" value={formData.phone} onChange={hc} />

//                   <small className="mr-field-note">
//                     Please include <strong>+</strong> and the international
//                     dialing code, followed by the phone number. No spaces or
//                     special characters are permitted.
//                   </small>
//                 </Field>
//                 <Field label="Email *">
//                   <input
//                     type="email"
//                     name="email"
//                     value={formData.email}
//                     onChange={hc}
//                   />
//                 </Field>
//               </div>
//             </div>

//             <div className="mr-section">
//               <div className="mr-section-head">Bailliage Information</div>
//               <div className="mr-grid">
//                 <Field label="National Bailliage *">
//                   <Select
//                     classNamePrefix="react-select"
//                     options={nationalityOptions}
//                     value={
//                       nationalityOptions.find(
//                         (option) => option.value === formData.nationalBailliage,
//                       ) ||
//                       nationalityOptions.find(
//                         (option) => option.label === "Vietnam",
//                       )
//                     }
//                     onChange={(selectedOption) =>
//                       setFormData({
//                         ...formData,
//                         nationalBailliage: selectedOption
//                           ? selectedOption.value
//                           : "",
//                       })
//                     }
//                     placeholder="Select National Bailliage"
//                     isSearchable
//                     isClearable
//                   />
//                 </Field>
//                 <Field label="Provincial Bailliage *">
//                   <input
//                     name="provincialBailliage"
//                     value={formData.provincialBailliage}
//                     onChange={hc}
//                   />
//                 </Field>
//                 <Field label="Regional Bailliage *">
//                   <input
//                     name="regionalBailliage"
//                     value={formData.regionalBailliage}
//                     onChange={hc}
//                   />
//                 </Field>
//               </div>
//             </div>

//             <div className="mr-footer">
//               <button className="mr-btn mr-btn-ghost">Cancel</button>
//               <button className="mr-btn mr-btn-primary" onClick={goNext}>
//                 Next →
//               </button>
//             </div>
//           </>
//         )}

//         {/* ════ STEP 2: Membership ════ */}
//         {step === 2 && (
//           <>
//             <div className="mr-section">
//               <div className="mr-section-head">Membership Information</div>
//               <div className="mr-grid">
//                 <Field label="Sponsor #1">
//                   <input
//                     name="membershipSponsor1"
//                     value={formData.membershipSponsor1}
//                     onChange={hc}
//                   />
//                 </Field>
//                 <Field label="Sponsor #2">
//                   <input
//                     name="membershipSponsor2"
//                     value={formData.membershipSponsor2}
//                     onChange={hc}
//                   />
//                 </Field>
//                 <Field label="Type of Membership" full>
//                   <div className="mr-toggle-group">
//                     <button
//                       type="button"
//                       className={`mr-toggle-btn ${
//                         formData.membershipType === "Amateur" ? "active" : ""
//                       }`}
//                       onClick={() =>
//                         setFormData({
//                           ...formData,
//                           membershipType: "Amateur",
//                         })
//                       }
//                     >
//                       Amateur
//                     </button>

//                     <button
//                       type="button"
//                       className={`mr-toggle-btn ${
//                         formData.membershipType === "Professional"
//                           ? "active"
//                           : ""
//                       }`}
//                       onClick={() =>
//                         setFormData({
//                           ...formData,
//                           membershipType: "Professional",
//                         })
//                       }
//                     >
//                       Professional
//                     </button>
//                   </div>
//                 </Field>
//                 <Field label="Grade">
//                   <select name="grade" value={formData.grade} onChange={hc}>
//                     <option value="">Select Grade</option>

//                     <option value="Académie Brillat-Savarin – Chancelier Délégué">
//                       Académie Brillat-Savarin – Chancelier Délégué
//                     </option>

//                     <option value="Chancelier Honoraire">
//                       Chancelier Honoraire
//                     </option>

//                     <option value="Chancelier Provincial">
//                       Chancelier Provincial
//                     </option>

//                     <option value="Chancelier Provincial Honoraire">
//                       Chancelier Provincial Honoraire
//                     </option>

//                     <option value="Chargé de Missions">
//                       Chargé de Missions
//                     </option>

//                     <option value="Chargé de Missions Honoraire">
//                       Chargé de Missions Honoraire
//                     </option>

//                     <option value="Chargé de Missions Provincial">
//                       Chargé de Missions Provincial
//                     </option>

//                     <option value="Chargé de Missions Provincial Honoraire">
//                       Chargé de Missions Provincial Honoraire
//                     </option>

//                     <option value="Chambellan">Chambellan</option>

//                     <option value="Chambellan Honoraire">
//                       Chambellan Honoraire
//                     </option>

//                     <option value="Chambellan Provincial">
//                       Chambellan Provincial
//                     </option>

//                     <option value="Chambellan Provincial Honoraire">
//                       Chambellan Provincial Honoraire
//                     </option>

//                     <option value="Chancelier">Chancelier</option>

//                     <option value="Chancelier Argentier">
//                       Chancelier Argentier
//                     </option>

//                     <option value="Chancelier Argentier Honoraire">
//                       Chancelier Argentier Honoraire
//                     </option>

//                     <option value="Chancelier Argentier Provincial">
//                       Chancelier Argentier Provincial
//                     </option>

//                     <option value="Chancelier Argentier Provincial Honoraire">
//                       Chancelier Argentier Provincial Honoraire
//                     </option>

//                     <option value="Bailli d'Honneur">Bailli d'Honneur</option>

//                     <option value="Bailli">Bailli</option>

//                     <option value="Bailli Honoraire">Bailli Honoraire</option>

//                     <option value="Bailli Provincial">Bailli Provincial</option>

//                     <option value="Bailli Provincial Honoraire">
//                       Bailli Provincial Honoraire
//                     </option>

//                     <option value="Bouteiller">Bouteiller</option>

//                     <option value="Bouteiller Honoraire">
//                       Bouteiller Honoraire
//                     </option>

//                     <option value="Échanson">Échanson</option>

//                     <option value="Échanson Provincial">
//                       Échanson Provincial
//                     </option>

//                     <option value="Conseiller Culinaire">
//                       Conseiller Culinaire
//                     </option>

//                     <option value="Conseiller Gastronomique">
//                       Conseiller Gastronomique
//                     </option>

//                     <option value="Conseiller Professionnel">
//                       Conseiller Professionnel
//                     </option>

//                     <option value="Conseiller Gastronomique Provincial">
//                       Conseiller Gastronomique Provincial
//                     </option>

//                     <option value="Conseiller Culinaire Provincial">
//                       Conseiller Culinaire Provincial
//                     </option>

//                     <option value="Vice-Conseiller Culinaire">
//                       Vice-Conseiller Culinaire
//                     </option>

//                     <option value="Vice-Chargé de Missions">
//                       Vice-Chargé de Missions
//                     </option>

//                     <option value="Vice-Chancelier">Vice-Chancelier</option>

//                     <option value="Vice-Échanson">Vice-Échanson</option>

//                     <option value="Vice-Argentier">Vice-Argentier</option>

//                     <option value="Membre">Membre</option>

//                     <option value="Chevalier">Chevalier</option>

//                     <option value="Officier">Officier</option>

//                     <option value="Commandeur">Commandeur</option>

//                     <option value="Grand Officier">Grand Officier</option>

//                     <option value="Grand Commandeur">Grand Commandeur</option>
//                   </select>
//                 </Field>
//               </div>
//             </div>
//             <div className="mr-footer">
//               <button className="mr-btn mr-btn-ghost" onClick={goPrev}>
//                 ← Previous
//               </button>
//               <button className="mr-btn mr-btn-primary" onClick={goNext}>
//                 Next →
//               </button>
//             </div>
//           </>
//         )}

//         {/* ════ STEP 3: Dues ════ */}
//         {step === 3 && (
//           <>
//             <div className="mr-section">
//               <div className="mr-section-head">Dues Information</div>
//               <div className="mr-grid">
//                 <Field label="Relevant Year">
//                   <input
//                     type="number"
//                     name="relevantYear"
//                     placeholder="2026"
//                     value={formData.relevantYear}
//                     onChange={hc}
//                   />
//                 </Field>
//                 <Field label="Date of Registration">
//                   <input
//                     type="date"
//                     name="registrationDate"
//                     value={formData.registrationDate}
//                     onChange={hc}
//                   />
//                 </Field>
//                 <Field label="Price Category">
//                   <select
//                     name="priceCategory"
//                     value={formData.priceCategory}
//                     onChange={hc}
//                   >
//                     <option value="">Select Category</option>
//                     <option>Full admission : VND 20.000.000</option>
//                     <option>
//                       Current primary member's spouse: VND 18.800.000
//                     </option>
//                   </select>
//                 </Field>
//                 <Field label="Amount">
//                   <input
//                     type="number"
//                     name="membershipAmount"
//                     placeholder="0.00"
//                     value={formData.membershipAmount}
//                     onChange={hc}
//                   />
//                 </Field>
//               </div>
//             </div>

//             <div className="mr-footer">
//               <button className="mr-btn mr-btn-ghost" onClick={goPrev}>
//                 ← Previous
//               </button>
//               <button className="mr-btn mr-btn-primary" onClick={goNext}>
//                 Next →
//               </button>
//             </div>
//           </>
//         )}

//         {/* ════ STEP 4: Address ════ */}
//         {step === 4 && (
//           <>
//             <div className="mr-section mr-address-section">
//               <div className="mr-section-head">Personal Address</div>

//               <div className="mr-grid mr-address-grid">
//                 {/* Search Address */}
//                 <div className="mr-field mr-field-full mr-address-search">
//                   <label className="mr-label">Search address</label>

//                   <div className="mr-address-search-wrapper">
//                     <input
//                       name="searchAddress"
//                       placeholder="Start typing an address..."
//                       value={formData.searchAddress || ""}
//                       onChange={handleAddressSearch}
//                       onFocus={() => {
//                         if (addressSuggestions.length > 0) {
//                           setShowSuggestions(true);
//                         }
//                       }}
//                       autoComplete="off"
//                     />

//                     {isSearchingAddress && (
//                       <div className="mr-address-loading">Searching...</div>
//                     )}

//                     {showSuggestions && addressSuggestions.length > 0 && (
//                       <div className="mr-address-suggestions">
//                         {addressSuggestions.map((place, index) => (
//                           <button
//                             type="button"
//                             key={`${place.place_id || place.formatted}-${index}`}
//                             className="mr-address-suggestion"
//                             onClick={() => handleSelectAddress(place)}
//                           >
//                             <span className="mr-address-suggestion-icon">
//                               📍
//                             </span>

//                             <span>{place.formatted}</span>
//                           </button>
//                         ))}
//                       </div>
//                     )}
//                   </div>

//                   <div className="mr-field-note">
//                     Start typing an address to see suggestions. Selecting a
//                     suggestion will automatically fill in the address details
//                     below. You can also enter the details manually.
//                   </div>
//                 </div>

//                 {/* Address */}
//                 <Field label="Address *" full>
//                   <input
//                     name="address"
//                     placeholder="Address"
//                     value={formData.address || ""}
//                     onChange={hc}
//                   />
//                 </Field>

//                 {/* Additional Information - 2 columns */}
//                 <div className="mr-address-additional">
//                   <Field label="Additional information">
//                     <input
//                       name="additionalInfo"
//                       placeholder="Additional information"
//                       value={formData.additionalInfo || ""}
//                       onChange={hc}
//                     />
//                   </Field>
//                 </div>

//                 {/* Country - 1 column */}
//                 <div className="mr-address-country">
//                   <Field label="Country *">
//                     <input
//                       name="country"
//                       placeholder="Country"
//                       value={formData.country || ""}
//                       onChange={hc}
//                     />
//                   </Field>
//                 </div>

//                 {/* State */}
//                 <Field label="State *">
//                   <input
//                     name="state"
//                     placeholder="State"
//                     value={formData.state || ""}
//                     onChange={hc}
//                   />
//                 </Field>

//                 {/* Postal Code */}
//                 <Field label="Postal code *">
//                   <input
//                     name="postalCode"
//                     placeholder="Postal code"
//                     value={formData.postalCode || ""}
//                     onChange={hc}
//                   />
//                 </Field>

//                 {/* City */}
//                 <Field label="City *">
//                   <input
//                     name="city"
//                     placeholder="City"
//                     value={formData.city || ""}
//                     onChange={hc}
//                   />
//                 </Field>
//               </div>
//             </div>

//             <div className="mr-footer">
//               <button
//                 type="button"
//                 className="mr-btn mr-btn-ghost"
//                 onClick={goPrev}
//               >
//                 ← BACK
//               </button>

//               <button
//                 type="button"
//                 className="mr-btn mr-btn-primary"
//                 onClick={() => setSubmitted(true)}
//               >
//                 CREATE +
//               </button>
//             </div>
//           </>
//         )}
//       </div>
//     </div>
//   );
// }
import React, { useState, useEffect } from "react";
import "./MemberRegistration.css";
import cdrLogo from "../assets/icons/CDR-Logo.png";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import axios from "axios";
import countryList from "react-select-country-list";
import { useAuthStore } from "../Services/authStore";
import { toastSuccess, toastError } from "../Services/toaster";

const STEPS = [
  { num: 1, label: "Personal" },
  { num: 2, label: "Membership" },
  { num: 3, label: "Dues" },
  { num: 4, label: "Address" },
];

function StepTracker({ current }) {
  return (
    <div className="mr-stepbar">
      {STEPS.map((s, i) => (
        <React.Fragment key={s.num}>
          <div
            className={
              "mr-step" +
              (current === s.num ? " mr-step-active" : "") +
              (current > s.num ? " mr-step-done" : "")
            }
          >
            <div className="mr-step-circle">
              {current > s.num ? "✓" : s.num}
            </div>
            <span className="mr-step-label">{s.label}</span>
          </div>
          {i < STEPS.length - 1 && (
            <div
              className={
                "mr-step-line" + (current > s.num ? " mr-line-done" : "")
              }
            />
          )}
        </React.Fragment>
      ))}
    </div>
  );
}

function Field({ label, children, full }) {
  return (
    <div className={"mr-field" + (full ? " mr-field-full" : "")}>
      <label className="mr-label">{label}</label>
      {children}
    </div>
  );
}

export default function MemberRegistration() {
  const [step, setStep] = useState(1);
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formError, setFormError] = useState("");
  const [priceCategories, setPriceCategories] = useState([]);
  const [grades, setGrades] = useState([]);
  const navigate = useNavigate();
  const [addressSuggestions, setAddressSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [isSearchingAddress, setIsSearchingAddress] = useState(false);

  const API_URL = process.env.REACT_APP_API_URL;

  // Country dropdown options
  const nationalityOptions = countryList().getData();

  const [formData, setFormData] = useState({
    nationalBailliage: "VN",
    dietaryRestrictions: "",
    firstName: "",
    lastName: "",
    birthday: "",
    title: "",
    gender: "",
    nationality: "",
    spokenLanguages: "",
    spouseMember: "",
    gastronomicAssociation: "",
    phone: "",
    email: "",
    provincialBailliage: "",
    regionalBailliage: "",
    membershipSponsor1: "",
    membershipSponsor2: "",
    membershipType: "",
    grade: "",
    gradeId: 0,
    relevantYear: "",
    registrationDate: "",
    priceCategory: "",
    membershipAmount: "",
    paymentDate: "",
    searchAddress: "",
    address: "",
    additionalInfo: "",
    country: "",
    state: "",
    postalCode: "",
    city: "",
    rankId: 0,
  });

  const hc = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  // ─── Auto-load Step 3 data (Relevant Year + Registration Date) ───
  useEffect(() => {
    const today = new Date().toISOString().split("T")[0];
    const currentYear = new Date().getFullYear();

    setFormData((prev) => ({
      ...prev,
      registrationDate: today,
      relevantYear: currentYear,
    }));

    fetchPriceCategories();
    fetchGrades();
  }, []);

  // ─── GET /price-category/list/all ──────────────────────
  const fetchPriceCategories = async () => {
    try {
      const authToken = useAuthStore.getState().token;
      const res = await axios.get(`${API_URL}/price-category/list/all`, {
        headers: {
          Authorization: `Bearer ${authToken}`,
          accept: "application/json",
        },
      });
      const data = res.data?.data || res.data || [];
      setPriceCategories(
        data.filter((c) => c.is_active === true || c.is_active === 1),
      );
    } catch (err) {
      console.error("Failed to load price categories:", err.response?.data);
      toastError("Failed to load price categories");
    }
  };

  // ─── When Price Category is selected → auto-fill Amount ─
  const handlePriceCategoryChange = (e) => {
    const categoryId = e.target.value;
    const selectedCategory = priceCategories.find(
      (c) => c.id === parseInt(categoryId),
    );

    setFormData((prev) => ({
      ...prev,
      priceCategory: categoryId,
      membershipAmount: selectedCategory?.amount || 0,
    }));
  };

  const goNext = (e) => {
    e.preventDefault();
    if (step < 4) setStep(step + 1);
  };
  const goPrev = (e) => {
    e.preventDefault();
    if (step > 1) setStep(step - 1);
  };
  // ─── GET /garde/list/all ───────────────────────────────
  const fetchGrades = async () => {
    try {
      const authToken = useAuthStore.getState().token;

      const res = await axios.get(`${API_URL}/garde/list/all`, {
        headers: {
          Authorization: `Bearer ${authToken}`,
          accept: "application/json",
        },
      });

      console.log("Grade API response:", res.data);

      const data = res.data?.data || res.data || [];

      setGrades(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error(
        "Failed to load grades:",
        err.response?.data || err.message,
      );

      toastError("Failed to load grades");
    }
  };
  const handleAddressSearch = async (e) => {
    const value = e.target.value;

    setFormData((prev) => ({
      ...prev,
      searchAddress: value,
    }));

    if (value.trim().length < 3) {
      setAddressSuggestions([]);
      setShowSuggestions(false);
      return;
    }

    try {
      setIsSearchingAddress(true);

      const response = await axios.get(
        "https://api.geoapify.com/v1/geocode/autocomplete",
        {
          params: {
            text: value,
            format: "json",
            limit: 5,
            apiKey: process.env.REACT_APP_GEOAPIFY_API_KEY,
          },
        },
      );

      setAddressSuggestions(response.data.results || []);
      setShowSuggestions(true);
    } catch (error) {
      console.error(
        "Address search error:",
        error.response?.data || error.message,
      );

      setAddressSuggestions([]);
      setShowSuggestions(false);
    } finally {
      setIsSearchingAddress(false);
    }
  };

  const handleSelectAddress = (place) => {
    setFormData((prev) => ({
      ...prev,
      searchAddress: place.formatted || "",
      address:
        [place.housenumber, place.street].filter(Boolean).join(" ") ||
        place.address_line1 ||
        "",
      additionalInfo: place.address_line2 || "",
      city:
        place.city || place.town || place.village || place.municipality || "",
      state: place.state || place.state_district || "",
      country: place.country || "",
      postalCode: place.postcode || "",
    }));

    setShowSuggestions(false);
    setAddressSuggestions([]);
  };

  // ─── Validate Form ────────────────────────────────────
  const validateForm = () => {
    if (!formData.firstName.trim()) {
      toastError("First name is required.");
      return false;
    }
    if (!formData.lastName.trim()) {
      toastError("Last name is required.");
      return false;
    }
    if (!formData.birthday) {
      toastError("Birthday is required.");
      return false;
    }
    if (!formData.gender) {
      toastError("Gender is required.");
      return false;
    }
    if (!formData.nationality) {
      toastError("Nationality is required.");
      return false;
    }
    if (!formData.phone.trim()) {
      toastError("Phone number is required.");
      return false;
    }
    if (!formData.email.trim()) {
      toastError("Email is required.");
      return false;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      toastError("Please enter a valid email address.");
      return false;
    }
    return true;
  };

  // ─── Submit Member Registration ───────────────────────
  const handleSubmit = async () => {
    if (!validateForm()) {
      return;
    }

    setFormError("");
    setLoading(true);

    try {
      const authToken = useAuthStore.getState().token;

      const payload = {
        first_name: formData.firstName,
        last_name: formData.lastName,
        birth_date: formData.birthday,
        title: formData.title,
        gender: formData.gender,
        nationality: formData.nationality,
        additional_spoken_language: formData.spokenLanguages,
        spouse_member: formData.spouseMember || "No",
        other_associations: formData.gastronomicAssociation || "No",
        phone: formData.phone,
        email: formData.email,
        national_bailliage: formData.nationalBailliage,
        prov_bailliage: formData.provincialBailliage,
        reg_bailliage: formData.regionalBailliage,
        sponsor1: formData.membershipSponsor1 || "No",
        sponsor2: formData.membershipSponsor2 || "No",
        membership_type: formData.membershipType || "Amateur",
        grade_id: parseInt(formData.gradeId) || 0,
        relevant_year: parseInt(formData.relevantYear) || 0,
        registration_date:
          formData.registrationDate || new Date().toISOString().split("T")[0],
        price_category: formData.priceCategory || "",
        amount: parseFloat(formData.membershipAmount) || 0,
        address: formData.address || "",
        add_information: formData.additionalInfo || "",
        country: formData.country || "",
        state: formData.state || "",
        postal_code: formData.postalCode || "",
        city: formData.city || "",
        rank_id: parseInt(formData.rankId) || 0,
        diet_pref: formData.dietaryRestrictions || "",
      };

      const response = await axios.post(`${API_URL}/members`, payload, {
        headers: {
          Authorization: `Bearer ${authToken}`,
          accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      console.log("Member created:", response.data);
      toastSuccess("Member registered successfully!");
      setSubmitted(true);
    } catch (err) {
      console.error("Registration error:", err.response?.data);
      const detail = err.response?.data?.detail;
      const msg = Array.isArray(detail)
        ? detail.map((d) => `${d.loc?.join(".")} — ${d.msg}`).join("\n")
        : detail || "Failed to register member. Please try again.";
      setFormError(msg);
      toastError(msg);
    } finally {
      setLoading(false);
    }
  };

  // ── Success screen ────────────────────────────────────
  if (submitted)
    return (
      <div className="mr-page">
        <div className="mr-card mr-card-success">
          <div className="mr-success-ring">
            <img src={cdrLogo} alt="CDR" className="mr-success-logo" />
          </div>
          <h2 className="mr-success-title">Welcome to the Chaîne!</h2>
          <p className="mr-success-desc">
            <strong>
              {formData.firstName} {formData.lastName}
            </strong>{" "}
            has been successfully registered. The membership application is now
            pending review.
          </p>
          <button
            className="mr-btn mr-btn-primary"
            onClick={() => {
              setSubmitted(false);
              setStep(1);
              setFormData({
                firstName: "",
                lastName: "",
                birthday: "",
                title: "",
                gender: "",
                nationality: "",
                spokenLanguages: "",
                dietaryRestrictions: "",
                spouseMember: "",
                gastronomicAssociation: "",
                phone: "",
                email: "",
                nationalBailliage: "VN",
                provincialBailliage: "",
                regionalBailliage: "",
                membershipSponsor1: "",
                membershipSponsor2: "",
                membershipType: "",
                grade: "",
                gradeId: 0,
                relevantYear: new Date().getFullYear(),
                registrationDate: new Date().toISOString().split("T")[0],
                priceCategory: "",
                membershipAmount: "",
                paymentDate: "",
                searchAddress: "",
                address: "",
                additionalInfo: "",
                country: "",
                state: "",
                postalCode: "",
                city: "",
                rankId: 0,
              });
            }}
          >
            Register Another Member
          </button>

          <div className="mr-login-box">
            <p className="mr-login-text">Already have an account?</p>

            <button
              className="mr-login-btn"
              onClick={() => navigate("/MemberLogin")}
            >
              Sign In
            </button>
          </div>
        </div>
      </div>
    );

  return (
    <div className="mr-page">
      <div className="mr-card">
        {/* ── Header ── */}
        <div className="mr-header">
          <div className="mr-header-brand">
            <div className="mr-logo-ring">
              <img src={cdrLogo} alt="CDR Logo" className="mr-logo-img" />
            </div>
            <div>
              <h1 className="mr-title">Member Registration</h1>
              <p className="mr-subtitle">
                Chaîne des Rôtisseurs · New Member Admission
              </p>
            </div>
          </div>
          <StepTracker current={step} />
        </div>

        {/* ── Error Message ── */}
        {formError && <div className="mr-form-error">{formError}</div>}

        {/* ════ STEP 1: Personal ════ */}
        {step === 1 && (
          <>
            <div className="mr-section">
              <div className="mr-section-head">Personal Information</div>
              <div className="mr-grid">
                <Field label="Title *">
                  <select name="title" value={formData.title} onChange={hc}>
                    <option value="">Select</option>
                    <option>Lady</option>
                    <option>Miss</option>
                    <option>Mme.</option>
                    <option>Mr.</option>
                    <option>Mrs.</option>
                    <option>Ms.</option>
                    <option>prot.</option>
                    <option>Tan Sri Dato</option>
                    <option>Chef</option>
                    <option>Count</option>
                    <option>Dato</option>
                    <option>Dato Seri</option>
                    <option>Dr</option>
                  </select>
                </Field>
                <Field label="First Name *">
                  <input
                    name="firstName"
                    value={formData.firstName}
                    onChange={hc}
                  />
                </Field>
                <Field label="Last Name *">
                  <input
                    name="lastName"
                    value={formData.lastName}
                    onChange={hc}
                  />
                </Field>
                <Field label="Birthday *">
                  <input
                    type="date"
                    name="birthday"
                    value={formData.birthday}
                    onChange={hc}
                  />
                </Field>

                <Field label="Gender *">
                  <select name="gender" value={formData.gender} onChange={hc}>
                    <option value="">Select</option>
                    <option>Male</option>
                    <option>Female</option>
                    <option>Other</option>
                  </select>
                </Field>
                <Field label="Nationality *">
                  <Select
                    classNamePrefix="react-select"
                    options={nationalityOptions}
                    value={nationalityOptions.find(
                      (option) => option.label === formData.nationality,
                    )}
                    onChange={(selectedOption) =>
                      setFormData({
                        ...formData,
                        nationality: selectedOption ? selectedOption.label : "",
                      })
                    }
                    placeholder="Select Nationality"
                    isSearchable
                    isClearable
                  />
                </Field>

                <Field label="Additional Spoken Languages">
                  <select
                    name="spokenLanguages"
                    value={formData.spokenLanguages}
                    onChange={hc}
                  >
                    <option value="">Select Language</option>
                    <option value="Chinese">Chinese</option>
                    <option value="English">English</option>
                    <option value="Korean">Korean</option>
                    <option value="French">French</option>
                    <option value="Japanese">Japanese</option>
                    <option value="Spanish">Spanish</option>
                    <option value="German">German</option>
                    <option value="Italian">Italian</option>
                  </select>
                </Field>

                <Field label="Dietary Restrictions">
                  <select
                    name="hasDietaryRestrictions"
                    value={formData.hasDietaryRestrictions}
                    onChange={hc}
                  >
                    <option value="">Select</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>

                  {formData.hasDietaryRestrictions === "Yes" && (
                    <textarea
                      rows="2"
                      name="dietaryRestrictions"
                      placeholder="Please specify dietary restrictions"
                      value={formData.dietaryRestrictions}
                      onChange={hc}
                      style={{ marginTop: "10px" }}
                    />
                  )}
                </Field>
                <Field label="Spouse Member of La Chaîne">
                  <input
                    type="search"
                    name="spouseMember"
                    placeholder="Search ..."
                    value={formData.spouseMember}
                    onChange={hc}
                  />
                </Field>
                <Field label="Other Gastronomic Associations" full>
                  <textarea
                    rows="3"
                    name="gastronomicAssociation"
                    value={formData.gastronomicAssociation}
                    onChange={hc}
                  />
                </Field>
              </div>
            </div>

            <div className="mr-section">
              <div className="mr-section-head">Contact Information</div>
              <div className="mr-grid">
                <Field label="Personal Phone *">
                  <input name="phone" value={formData.phone} onChange={hc} />

                  <small className="mr-field-note">
                    Please include <strong>+</strong> and the international
                    dialing code, followed by the phone number. No spaces or
                    special characters are permitted.
                  </small>
                </Field>
                <Field label="Email *">
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={hc}
                  />
                </Field>
              </div>
            </div>

            <div className="mr-section">
              <div className="mr-section-head">Bailliage Information</div>
              <div className="mr-grid">
                <Field label="National Bailliage *">
                  <Select
                    classNamePrefix="react-select"
                    options={nationalityOptions}
                    value={
                      nationalityOptions.find(
                        (option) => option.value === formData.nationalBailliage,
                      ) ||
                      nationalityOptions.find(
                        (option) => option.label === "Vietnam",
                      )
                    }
                    onChange={(selectedOption) =>
                      setFormData({
                        ...formData,
                        nationalBailliage: selectedOption
                          ? selectedOption.value
                          : "",
                      })
                    }
                    placeholder="Select National Bailliage"
                    isSearchable
                    isClearable
                  />
                </Field>
                <Field label="Provincial Bailliage *">
                  <input
                    name="provincialBailliage"
                    value={formData.provincialBailliage}
                    onChange={hc}
                  />
                </Field>
                <Field label="Regional Bailliage *">
                  <input
                    name="regionalBailliage"
                    value={formData.regionalBailliage}
                    onChange={hc}
                  />
                </Field>
              </div>
            </div>

            <div className="mr-footer">
              <button
                className="mr-btn mr-btn-ghost"
                onClick={() => navigate(-1)}
              >
                Cancel
              </button>
              <button className="mr-btn mr-btn-primary" onClick={goNext}>
                Next →
              </button>
            </div>
          </>
        )}

        {/* ════ STEP 2: Membership ════ */}
        {step === 2 && (
          <>
            <div className="mr-section">
              <div className="mr-section-head">Membership Information</div>
              <div className="mr-grid">
                <Field label="Sponsor #1">
                  <input
                    name="membershipSponsor1"
                    value={formData.membershipSponsor1}
                    onChange={hc}
                  />
                </Field>
                <Field label="Sponsor #2">
                  <input
                    name="membershipSponsor2"
                    value={formData.membershipSponsor2}
                    onChange={hc}
                  />
                </Field>
                <Field label="Type of Membership" full>
                  <div className="mr-toggle-group">
                    <button
                      type="button"
                      className={`mr-toggle-btn ${
                        formData.membershipType === "Amateur" ? "active" : ""
                      }`}
                      onClick={() =>
                        setFormData({
                          ...formData,
                          membershipType: "Amateur",
                        })
                      }
                    >
                      Amateur
                    </button>

                    <button
                      type="button"
                      className={`mr-toggle-btn ${
                        formData.membershipType === "Professional"
                          ? "active"
                          : ""
                      }`}
                      onClick={() =>
                        setFormData({
                          ...formData,
                          membershipType: "Professional",
                        })
                      }
                    >
                      Professional
                    </button>
                  </div>
                </Field>
                <Field label="Grade">
                  <select
                    name="gradeId"
                    value={formData.gradeId}
                    onChange={(e) => {
                      const selectedGradeId = e.target.value;

                      const selectedGrade = grades.find(
                        (grade) => String(grade.id) === String(selectedGradeId),
                      );

                      setFormData((prev) => ({
                        ...prev,
                        gradeId: selectedGradeId,
                        grade:
                          selectedGrade?.name ||
                          selectedGrade?.grade_name ||
                          selectedGrade?.description ||
                          "",
                      }));
                    }}
                  >
                    <option value="">Select Grade</option>

                    {grades.map((grade) => (
                      <option key={grade.id} value={grade.id}>
                        {grade.name ||
                          grade.grade_name ||
                          grade.description ||
                          `Grade ${grade.id}`}
                      </option>
                    ))}
                  </select>
                </Field>
              </div>
            </div>
            <div className="mr-footer">
              <button className="mr-btn mr-btn-ghost" onClick={goPrev}>
                ← Previous
              </button>
              <button className="mr-btn mr-btn-primary" onClick={goNext}>
                Next →
              </button>
            </div>
          </>
        )}

        {/* ════ STEP 3: Dues ════ */}
        {step === 3 && (
          <>
            <div className="mr-section">
              <div className="mr-section-head">Dues Information</div>
              <div className="mr-grid">
                <Field label="Relevant Year *">
                  <input
                    type="number"
                    name="relevantYear"
                    value={formData.relevantYear}
                    onChange={hc}
                    readOnly
                    style={{ background: "#f5f5f5", cursor: "not-allowed" }}
                  />
                </Field>

                <Field label="Date of registration *">
                  <input
                    type="date"
                    name="registrationDate"
                    value={formData.registrationDate}
                    onChange={hc}
                    readOnly
                    style={{ background: "#f5f5f5", cursor: "not-allowed" }}
                  />
                </Field>

                <Field label="Price category *">
                  <select
                    name="priceCategory"
                    value={formData.priceCategory}
                    onChange={handlePriceCategoryChange}
                  >
                    <option value="">Select Price Category</option>
                    {priceCategories.map((cat) => (
                      <option key={cat.id} value={cat.id}>
                        {cat.description}
                      </option>
                    ))}
                  </select>
                </Field>

                <Field label="Amount">
                  <input
                    type="number"
                    name="membershipAmount"
                    value={formData.membershipAmount}
                    readOnly
                    style={{ background: "#f5f5f5", cursor: "not-allowed" }}
                  />
                </Field>
              </div>
            </div>

            <div className="mr-footer">
              <button className="mr-btn mr-btn-ghost" onClick={goPrev}>
                ← Previous
              </button>
              <button className="mr-btn mr-btn-primary" onClick={goNext}>
                Next →
              </button>
            </div>
          </>
        )}

        {/* ════ STEP 4: Address ════ */}
        {step === 4 && (
          <>
            <div className="mr-section mr-address-section">
              <div className="mr-section-head">Personal Address</div>

              <div className="mr-grid mr-address-grid">
                {/* Search Address */}
                <div className="mr-field mr-field-full mr-address-search">
                  <label className="mr-label">Search address</label>

                  <div className="mr-address-search-wrapper">
                    <input
                      name="searchAddress"
                      placeholder="Start typing an address..."
                      value={formData.searchAddress || ""}
                      onChange={handleAddressSearch}
                      onFocus={() => {
                        if (addressSuggestions.length > 0) {
                          setShowSuggestions(true);
                        }
                      }}
                      autoComplete="off"
                    />

                    {isSearchingAddress && (
                      <div className="mr-address-loading">Searching...</div>
                    )}

                    {showSuggestions && addressSuggestions.length > 0 && (
                      <div className="mr-address-suggestions">
                        {addressSuggestions.map((place, index) => (
                          <button
                            type="button"
                            key={`${place.place_id || place.formatted}-${index}`}
                            className="mr-address-suggestion"
                            onClick={() => handleSelectAddress(place)}
                          >
                            <span className="mr-address-suggestion-icon">
                              📍
                            </span>

                            <span>{place.formatted}</span>
                          </button>
                        ))}
                      </div>
                    )}
                  </div>

                  <div className="mr-field-note">
                    Start typing an address to see suggestions. Selecting a
                    suggestion will automatically fill in the address details
                    below. You can also enter the details manually.
                  </div>
                </div>

                {/* Address */}
                <Field label="Address *" full>
                  <input
                    name="address"
                    placeholder="Address"
                    value={formData.address || ""}
                    onChange={hc}
                  />
                </Field>

                {/* Additional Information - 2 columns */}
                <div className="mr-address-additional">
                  <Field label="Additional information">
                    <input
                      name="additionalInfo"
                      placeholder="Additional information"
                      value={formData.additionalInfo || ""}
                      onChange={hc}
                    />
                  </Field>
                </div>

                {/* Country - 1 column */}
                <div className="mr-address-country">
                  <Field label="Country *">
                    <input
                      name="country"
                      placeholder="Country"
                      value={formData.country || ""}
                      onChange={hc}
                    />
                  </Field>
                </div>

                {/* State */}
                <Field label="State *">
                  <input
                    name="state"
                    placeholder="State"
                    value={formData.state || ""}
                    onChange={hc}
                  />
                </Field>

                {/* Postal Code */}
                <Field label="Postal code *">
                  <input
                    name="postalCode"
                    placeholder="Postal code"
                    value={formData.postalCode || ""}
                    onChange={hc}
                  />
                </Field>

                {/* City */}
                <Field label="City *">
                  <input
                    name="city"
                    placeholder="City"
                    value={formData.city || ""}
                    onChange={hc}
                  />
                </Field>
              </div>
            </div>

            <div className="mr-footer">
              <button
                type="button"
                className="mr-btn mr-btn-ghost"
                onClick={goPrev}
                disabled={loading}
              >
                ← BACK
              </button>

              <button
                type="button"
                className="mr-btn mr-btn-primary"
                onClick={handleSubmit}
                disabled={loading}
              >
                {loading ? "CREATING..." : "CREATE +"}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
